var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-external-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.7264 6.82094L14.7264 2.7331M14.7264 2.7331H10.6386M14.7264 2.7331L8.59465 8.86485M7.23203 2.73309H5.73316C4.58846 2.73309 4.01611 2.73309 3.57889 2.95587C3.1943 3.15182 2.88162 3.4645 2.68566 3.84909C2.46289 4.28631 2.46289 4.85866 2.46289 6.00336V11.7263C2.46289 12.871 2.46289 13.4434 2.68566 13.8806C2.88162 14.2652 3.1943 14.5779 3.57889 14.7738C4.01611 14.9966 4.58846 14.9966 5.73316 14.9966H11.4561C12.6008 14.9966 13.1732 14.9966 13.6104 14.7738C13.995 14.5779 14.3077 14.2652 14.5036 13.8806C14.7264 13.4434 14.7264 12.871 14.7264 11.7263V10.2275",
    stroke: "#606060",
    strokeWidth: 1.63514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.9d5d1e9251cacb511857a8f4791486d9.svg";
export { ForwardRef as ReactComponent };